import { Validators } from '@angular/forms';

export const threeFields = [
  {
    type: 'input',
    label: 'Username',
    name: 'username',
    placeholder: 'Username',
    validation: [Validators.required],
    icon: 'user',
  },
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    placeholder: 'Password',
    validation: [Validators.required],
    icon: 'password',
  },
  {
    type: 'input',
    label: 'Department ID',
    name: 'depId',
    placeholder: 'Practice ID',
    validation: [Validators.required],
    icon: 'doctor',
  },
  {
    label: 'Login',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
  },
];

export const threeFieldsMinbody = [
  {
    type: 'input',
    label: 'Username',
    name: 'username',
    placeholder: 'Username',
    validation: [Validators.required],
    icon: 'user',
  },
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    placeholder: 'Password',
    validation: [Validators.required],
    icon: 'password',
  },
  {
    type: 'input',
    label: 'Department ID',
    name: 'depId',
    placeholder: 'Studio ID',
    validation: [Validators.required],
    icon: 'doctor',
  },
  {
    label: 'Login',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
  },
];

export const threeFieldsEnvision = [
  {
    type: 'input',
    label: 'Username',
    name: 'username',
    placeholder: 'Username',
    validation: [Validators.required],
    icon: 'user',
  },
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    placeholder: 'Password',
    validation: [Validators.required],
    icon: 'password',
  },
  {
    type: 'input',
    label: 'Department ID',
    name: 'depId',
    placeholder: 'Company ID',
    validation: [Validators.required],
    icon: 'doctor',
  },
  {
    label: 'Login',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
  },
];

export const threeFieldsAesthetic = [
  {
    type: 'input',
    label: 'Username',
    name: 'username',
    placeholder: 'Username',
    validation: [Validators.required],
    icon: 'user',
  },
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    placeholder: 'Password',
    validation: [Validators.required],
    icon: 'password',
  },
  {
    type: 'input',
    label: 'Department ID',
    name: 'depId',
    placeholder: 'Company ID',
    validation: [Validators.required],
    icon: 'doctor',
  },
  {
    label: 'Login',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
  },
];
